<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" :title="$t('Configurazione')">
    <template v-if="wizard.askSiteTransfer || wizard.askMailTransfer">
      <wizard-question :title="$t('Attivazione: questo servizio è?')">
        <pf-radio
          :label="$t('Una nuova attivazione')"
          name="new_service"
          :value="true"
          :checked="wizard.newService"
          @change="wizard.newService = true"
          ouia-id="wizard-config-new-activation"
          required
        />
        <pf-radio
          :label="$t('Un servizio già esistente da trasferire su Artera')"
          name="new_service"
          :value="false"
          :checked="wizard.newService === false"
          @change="wizard.newService = false"
          ouia-id="wizard-config-existing"
          required
        />
      </wizard-question>

      <pf-flex>
        <pf-flex-item>
          <wizard-question
            v-if="wizard.askSiteTransfer && wizard.newService === false"
            :title="$t('Vuoi che ci occupiamo noi del trasferimento del sito web?')"
            :tooltip="$t('Al termine dell\'ordine ti chiederemo tutti i dati necessari per effettuare il trasferimento dall\'attuale provider')"
          >
            <pf-radio
              :label="$t('Sì')"
              name="site_transfer"
              :value="true"
              :checked="wizard.siteTransfer"
              @change="wizard.siteTransfer = true"
              ouia-id="wizard-config-site-transfer"
              required
            />
            <pf-radio
              :label="$t('No')"
              name="site_transfer"
              :value="false"
              :checked="wizard.siteTransfer === false"
              @change="wizard.siteTransfer = false"
              ouia-id="wizard-config-site-transfer"
              required
            />
          </wizard-question>
        </pf-flex-item>
        <pf-flex-item>
          <wizard-question
            v-if="wizard.askMailTransfer && wizard.newService === false"
            :title="$t('Vuoi che ci occupiamo noi del trasferimento delle mail?')"
            :tooltip="$t('Al termine dell\'ordine ti chiederemo di fornirci l\'attuale server IMAP e la lista delle caselle attive con le relative password')"
          >
            <pf-radio
              :label="$t('Sì')"
              name="mail_transfer"
              :value="true"
              :checked="wizard.mailTransfer"
              @change="wizard.mailTransfer = true"
              ouia-id="wizard-config-mail-transfer"
              required
            />
            <pf-radio
              :label="$t('No')"
              name="mail_transfer"
              :value="false"
              :checked="wizard.mailTransfer === false"
              @change="wizard.mailTransfer = false"
              ouia-id="wizard-config-mail-transfer"
              required
            />
          </wizard-question>
          <small v-if="wizard.askMailTransfer && wizard.newService === false">{{ $t("IMPORTANTE: per poter procedere con il trasferimento delle caselle mail è necessario che il servizio IMAP sia attivo sull'attuale provider") }}</small>
        </pf-flex-item>
      </pf-flex>
    </template>
    <wizard-question
      v-if="wizard.siteTransfer || wizard.mailTransfer"
      :title="$t('Occorre effettuare trasferimento al di fuori dell\'orario di ufficio (in serata o durante il weekend)?')"
    >
      <pf-radio
        :label="$t('Sì')"
        name="extra_time_transfer"
        :value="true"
        :checked="wizard.extraTimeTransfer"
        @change="wizard.extraTimeTransfer = true"
        ouia-id="wizard-config-extraTimeTransfer"
        required
      />
      <pf-radio
        :label="$t('No')"
        name="extra_time_transfer"
        :value="false"
        :checked="wizard.extraTimeTransfer === false"
        @change="wizard.extraTimeTransfer = false"
        ouia-id="wizard-config-extraTimeTransfer"
        required
      />
      <wizard-price-tag :product="wizard.getProdotto(wizard.codiciProdottiAddon.extraTimeTransferProduct)"/>
    </wizard-question>

    <template v-if="wizard.askConfigurazione">
      <pf-title h="2" class="pf-v6-u-mt-2xl">{{ $t('Configurazione applicativa')}}</pf-title>

      <wizard-question v-if="wizard.askDb" :title="$t('Versione MySQL')">
        <template #description>{{ $t('Indicaci quale versione di MySQL vuoi attivare.') }}</template>
        <wizard-question-options name="mysql" v-model="wizard.db" :options="wizard.filteredOpzioniDb" :null-label="$t('Non necessario')"/>
      </wizard-question>

      <wizard-question v-if="wizard.askPhp" :title="$t('Versione PHP')">
        <template #description>{{ $t('Indicaci quale versione di PHP vuoi attivare.') }}</template>
        <wizard-question-options name="php" v-model="wizard.php" :options="wizard.filteredOpzioniPhp" :null-label="$t('Non necessario')"/>
      </wizard-question>

      <wizard-question v-if="wizard.askTecnologie" :title="$t('Tecnologie e applicativi')">
        <template #description>{{ $t('Indicaci quali di queste tecnologie verranno utilizzate.') }}</template>
        <wizard-question-tecnologie v-model="wizard.tecnologie" />
      </wizard-question>
    </template>
  </wizard-form>
</template>

<style scoped>
.required-hidden{
  position: relative;
  width: 1px;
  height:1px;
  left: 25px;
}
</style>

<script lang="ts" setup>
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '../composition';

import WizardQuestion from '../questions/wizard-question.vue';
import WizardQuestionTecnologie from '../questions/wizard-question-tecnologie.vue';
import wizardQuestionOptions from '../questions/wizard-question-options.vue';
import WizardForm from '../wizard-form.vue';
import wizardPriceTag from '../wizard-price-tag.vue';

defineOptions({
  name: 'WizardStepConfigurazione',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep({
  isEnabled: wizard => wizard.askConfigurazione || wizard.askSiteTransfer || wizard.askMailTransfer,
});

defineExpose({
  isEnabled,
});
</script>
